document.addEventListener('DOMContentLoaded', function () {
  const mql = window.matchMedia('(max-width: 749px)');
  const containers = document.querySelectorAll('.mobile-toggle-text-container');

  containers.forEach(setup);

  // Re-applique quand on passe mobile <-> desktop
  try {
    mql.addEventListener('change', () => containers.forEach(resetAndSetup));
  } catch (e) {
    // Safari < 14
    mql.addListener(() => containers.forEach(resetAndSetup));
  }

  function resetAndSetup(container) {
    teardown(container);
    setup(container);
  }

  function teardown(container) {
    if (!container.dataset.rtEnhanced) return;
    if (container.dataset.rtOriginal) {
      container.innerHTML = container.dataset.rtOriginal;
    }
    delete container.dataset.rtEnhanced;
  }

  function setup(container) {
    const isMobile = mql.matches;

    const mobileCollapse = (container.dataset.mobileCollapse || 'false') === 'true';
    const desktopCollapse = (container.dataset.desktopCollapse || 'false') === 'true';

    const enabled = isMobile ? mobileCollapse : desktopCollapse;
    const truncate = parseInt(
      isMobile ? (container.dataset.mobileTruncate || '200')
               : (container.dataset.desktopTruncate || '300'),
      10
    );

    if (!enabled) return;

    // Sauvegarde le HTML original pour teardown
    if (!container.dataset.rtOriginal) {
      container.dataset.rtOriginal = container.innerHTML;
    }

    const firstParagraph = container.querySelector('p');
    if (!firstParagraph) return;

    const firstText = (firstParagraph.textContent || '').trim();
    if (firstText.length <= truncate) return;

    // --- Version courte ---
    const shortWrap = document.createElement('div');
    shortWrap.className = 'rte rc-short';

    // Cloner titres/sous-titres
    const headingNodes = container.querySelectorAll('h1,h2,h3,h4,h5,h6,.subheading');
    headingNodes.forEach(h => shortWrap.appendChild(h.cloneNode(true)));

    const truncatedP = document.createElement('p');
    truncatedP.textContent = firstText.substring(0, truncate) + '…';
    shortWrap.appendChild(truncatedP);

    // --- Version longue (HTML original) ---
    const fullWrap = document.createElement('div');
    fullWrap.className = 'rte rc-full';
    fullWrap.innerHTML = container.innerHTML;

    // --- Toggle ---
    const details = document.createElement('details');
    details.className = 'rc-details rte';

    const summary = document.createElement('summary');
    summary.className = 'rc-toggle';
    summary.innerHTML = '<span class="rc-more">Voir plus</span><span class="rc-less">Voir moins</span>';

    details.appendChild(summary);
    details.appendChild(fullWrap);

    // Injecter
    container.innerHTML = '';
    container.appendChild(shortWrap);
    container.appendChild(details);
    container.dataset.rtEnhanced = '1';

    // Masquer / afficher l’aperçu court
    details.addEventListener('toggle', () => {
      shortWrap.style.display = details.open ? 'none' : 'block';
    });
  }
});
